import { connect } from 'react-redux';
import { Nav } from './nav';

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.currentUser,
    clientData: state.user.clientData
  };
};

export default connect(mapStateToProps)(Nav);